import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
class InvoiceDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: {},
            branches: [],
            formData: {
                due_date: '',
                payment_status: '',
                vat_amount: '',
                total_amount: '',
                description: '',
                branch_id: ''
            },

            isLoad: true,
            loading: false,
        }
    }
    async componentDidMount() {
        this.getInvoiceInfo();
        this.setState({
            branches: await getBranches(),
        })
    }
    getInvoiceInfo = async () => {
        const invoiceID = this.props.match.params.id;
        try {
            const response = await apiCall('business/parasut/einbox-detail/' + invoiceID, 'get', null);

            this.setState({ invoice: response, isLoad: false });
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    due_date: response.due_date,
                    payment_status: response.payment_status === "Ödendi" ? "paid" : "unpaid",
                    vat_amount: response.vat_amount || 0,
                    total_amount: response.total_amount || 0,
                    description: response.description || '',
                    branch_id: response.branch_id || '',
                }
            }));

        } catch (e) {
            this.setState({ isLoad: false });
        }
    }


    handleInvoiceChange = (event) => {
        const { id, value } = event.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }));
    };
    openCustomerDetail = (e) => {
        e.preventDefault();
        const link = `${process.env.PUBLIC_URL}/customer-detail/${this.state.invoice.customer_id}`
        window.open(link, "_blank");
    }
    showInvoice = (e) => {
        e.preventDefault();
        //const link = `${process.env.REACT_APP_MAIN_URL}/p/invoice/show/${this.state.invoice.invoice_id}`
        window.open(this.state.invoice.sharing_preview_url, "_blank");
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const invoiceFormData = new FormData();
        Object.keys(formData).forEach(key => {
            invoiceFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/parasut/update/einbox/' + this.state.invoice.id, 'post', invoiceFormData);
            await this.getInvoiceInfo();
            mainHelper.toastMessage(response.status, response.message)
            this.setState({ loading: false });

        } catch (e) {
            this.setState({ loading: false });
        }

    }
    createReceivable = async () => {

        const result = await Swal.fire({
            title: 'Uyarı',
            text: "Mevcut toplam tutar üzerinden cari oluşturulacaktır.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, oluştur!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);
                const data = {
                    due_date: this.state.invoice.due_date,
                    payment_status: this.state.invoice.payment_status,
                    amount: this.state.invoice.total_amount,
                    description: this.state.invoice.description,
                    branch_id: this.state.invoice.branch_id,
                    customer_id: this.state.invoice.customer_id,
                }
                if (!this.state.invoice.total_amount || !this.state.invoice.branch_id || !this.state.invoice.customer_id || !this.state.invoice.due_date) {
                    Swal.fire(
                        'Uyarı!',
                        'Toplam tutar,şube,vade tarihi ve müşteri alanlarını kontrol ediniz!',
                        'warning'
                    );
                    return false;
                }
                try {
                    await apiCall('business/receivable/add-from-einbox/' + this.state.invoice.id, 'post', data);
                    await this.getInvoiceInfo();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Uyarı!',
                    'Cari başarıyla oluşturuldu.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Oluşturma işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const { invoice, loading, branches } = this.state;
        const { userPermissions } = this.props;
        const userHasCreateInvoice = userPermissions.includes('invoice process');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Fatura detayları"
                            Breadcrumb={[
                                { name: "Gelen Kutusu", navigate: "einbox" },
                                { name: "Detay", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div>
                                        {invoice && (
                                            <div className="body">
                                                <h4 className="text-center" style={{
                                                    color: "rgb(51 51 51 / 65%)", fontWeight: "bold"
                                                }}>
                                                    Fatura Kayıt Tarihi : {this.state.invoice.registered_at && mainHelper.dateFormat(this.state.invoice.registered_at)}
                                                </h4>
                                                <div
                                                    className="form-group d-flex justify-content-between align-items-center">

                                                    {invoice.invoice_id && (
                                                        <button onClick={this.showInvoice}
                                                            className="btn btn-outline-warning">
                                                            Fatura Pdf Görüntüle
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="body">
                                            {invoice && (
                                                <>
                                                    <h6>Müşteri</h6>
                                                    <div className="media">
                                                        <div className="media-left m-r-15">
                                                            <img
                                                                alt="User"
                                                                className="user-photo media-object"
                                                                src={`https://ui-avatars.com/api/?name=${invoice.name}&color=7F9CF5&background=EBF4FF`}
                                                            />
                                                        </div>
                                                        <div className="media-body">
                                                            <p>Ad Soyad: {invoice.name || 'Yok'}</p>
                                                            <p>Ünvan: {invoice.title || 'Yok.'}</p>
                                                            <p>Vergi veya Tc No: {invoice.vkn || 'Yok.'}</p>
                                                        </div>
                                                        <div className="media-body">
                                                            <a onClick={this.openCustomerDetail} href="#!"
                                                                className="btn btn-outline-primary"
                                                                id="btn-upload-photo">
                                                                <i className="icon-pencil"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                    <div className="body">
                                        <div className="row clearfix">
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="total_amount"
                                                        className="font-weight-bold text-cyan">
                                                        Şube
                                                    </label>
                                                    <select id='branch_id'
                                                        className="form-control"
                                                        value={this.state.formData.branch_id}
                                                        onChange={this.handleInvoiceChange}>
                                                        <option value="">Şube Seçiniz</option>
                                                        {branches && (branches.map(branch => (
                                                            <option key={branch.id}
                                                                value={branch.id}>{branch.name}</option>
                                                        )))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="total_amount"
                                                        className="font-weight-bold text-cyan">
                                                        Toplam Tutar
                                                    </label>
                                                    <input name="total_amount"
                                                        id="total_amount"
                                                        className="form-control"
                                                        type="number"
                                                        value={this.state.formData.total_amount}
                                                        onChange={this.handleInvoiceChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="vat_amount" className="font-weight-bold text-cyan">
                                                        Kdv Tutarı
                                                    </label>
                                                    <input name="vat_amount"
                                                        id="vat_amount"
                                                        className="form-control"
                                                        type="number"
                                                        value={this.state.formData.vat_amount}
                                                        onChange={this.handleInvoiceChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="due_date" className="font-weight-bold text-cyan">
                                                        Vade Tarihi
                                                    </label>
                                                    <input name="due_date"
                                                        id="due_date"
                                                        className="form-control"
                                                        type="date"
                                                        value={this.state.formData.due_date}
                                                        onChange={this.handleInvoiceChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="payment_status"
                                                        className="font-weight-bold text-cyan">
                                                        Ödeme Durumu
                                                    </label>
                                                    <select name="payment_status"
                                                        id='payment_status'
                                                        className="form-control"
                                                        value={this.state.formData.payment_status}
                                                        onChange={this.handleInvoiceChange}>
                                                        <option value="">Seçiniz</option>
                                                        <option value="paid">Ödendi</option>
                                                        <option value="unpaid">Ödenmedi</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="due_date" className="font-weight-bold text-cyan">
                                                        Fatura Detayı
                                                    </label>
                                                    <textarea name="due_date"
                                                        id="due_date"
                                                        className="form-control"
                                                        value={this.state.formData.description}
                                                        onChange={this.handleInvoiceChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="hidden-print col-md-12 text-right">
                                                <hr />
                                                {
                                                    this.state.invoice && (
                                                        this.state.invoice.is_receivable_created === 0 ? (
                                                            <button
                                                                disabled={!userHasCreateInvoice}
                                                                onClick={this.createReceivable}
                                                                className="btn btn-outline-success">
                                                                Cari Oluştur
                                                            </button>
                                                        ) : ""
                                                    )
                                                }

                                                {loading ? (
                                                    <button className="btn btn-outline-primary ml-2" disabled
                                                        style={{ textAlign: "-webkit-center" }}>
                                                        Lütfen Bekleyin...
                                                        <ReactLoading type="spin" width={'24px'}
                                                            height={'24px'} color="#268bd2" />
                                                    </button>
                                                ) : (
                                                    <button
                                                        disabled={!userHasCreateInvoice}
                                                        onClick={this.handleSubmit}
                                                        className="btn btn-outline-primary ml-2">
                                                        Kaydet
                                                    </button>

                                                )}

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(InvoiceDetail)));
